import { useMemo } from "react";
import * as SITE from "@/data/site";
import { useI18n } from "./I18nProvider";

// Keys whose values are identifiers/assets/contact details and must never be translated.
const SKIP = new Set(["slug", "to", "image", "icon", "logo", "logoIcon", "tel", "number", "email", "n", "name"]);
const KEYS = ["BRAND", "NAV", "NDIS", "SERVICES", "STEPS", "MISSION", "AIMS", "VALUES", "WHY", "TESTIMONIALS", "AGED_CARE", "FUNDING"];

const translateDeep = (v, t) => {
  if (Array.isArray(v)) return v.map((x) => translateDeep(x, t));
  if (typeof v === "string") return t(v);
  if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [k, SKIP.has(k) ? x : translateDeep(x, t)]));
  return v;
};

export const useSite = () => {
  const { t } = useI18n();
  return useMemo(() => Object.fromEntries(KEYS.map((k) => [k, translateDeep(SITE[k], t)])), [t]);
};
